import { utgApi } from "../../api/utgApi"
import { accessToken } from "../../hooks/useAccessToken"
import { utgListSignal, utgListLoadingSignal, utgListErrorSignal } from "../signals/utgSignals"

export async function fetchUtgList(businessEntityId, filter, config, accessToken) {
    utgListLoadingSignal.value = true
    utgListErrorSignal.value = null

    try {
        const result = await utgApi.fetchUtgList(businessEntityId, filter, config, accessToken)
        utgListSignal.value = result.serviceView
    }
    catch (err) {
        utgListErrorSignal.value = err.message
    }
    finally {
        utgListLoadingSignal.value = false
    }
}